import React from 'react';
import RelatedProduct from './RelatedProduct';

const RelatedProductsList = props => {
  const { goods } = props;

  return goods.map(good => <RelatedProduct key={good.id} good={good} />);
};

export default RelatedProductsList;
